module.exports = __webpack_public_path__ + "static/media/ic-play-black.a6ef1fef.svg";